// extracted by mini-css-extract-plugin
module.exports = {"display":"AsnUpdatesLive_display__3yVwI","header":"AsnUpdatesLive_header__6HOB8","tableArea":"AsnUpdatesLive_tableArea__Z-Ley","footer":"AsnUpdatesLive_footer__3F0jL"};